import Vue from 'vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate/dist/vee-validate.full'

// Use the provider immediately // Register it globally
Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

